import PropTypes from 'prop-types';

export default {
  classes: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  passengers: PropTypes.arrayOf(PropTypes.object),
  activePassenger: PropTypes.string,
  flights: PropTypes.arrayOf(PropTypes.object),
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
};



// WEBPACK FOOTER //
// ./src/containers/meals/common/mealsList/MealsListProps.js